import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {StarOutlineIcon} from "@pg-design/icons-module";

import {openSemanticSearchModal} from "../../semantic_search/state/semantic_search_modal_slice";
import {useAppDispatch} from "../../store/hooks";

export const HomePageSemanticSearchEntry = () => {
    const dispatch = useAppDispatch();

    return (
        <div className={wrapper}>
            <Button iconLeft={StarOutlineIcon} variant="filled_primary" size="x-small" onClick={() => dispatch(openSemanticSearchModal())}>
                Doradca AI
            </Button>
        </div>
    );
};

const wrapper = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 3
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {StarOutlineIcon} from "@pg-design/icons-module";

import {openSemanticSearchModal} from "../../semantic_search/state/semantic_search_modal_slice";
import {useAppDispatch} from "../../store/hooks";

export const HomePageSemanticSearchEntry = () => {
    const dispatch = useAppDispatch();

    return (
        <div className={wrapper}>
            <Button iconLeft={StarOutlineIcon} variant="filled_primary" size="x-small" onClick={() => dispatch(openSemanticSearchModal())}>
                Doradca AI
            </Button>
        </div>
    );
};

const wrapper = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: 3
});
